import { helpers } from './components/helpers.js';
import { slider } from './components/slider.js';
import { animations } from './components/animations.js';

window.theme = {
	globals: {
		isTouch: typeof window !== 'undefined' && 'ontouchstart' in window,
	},

	init: function () {
		helpers.touch();
		helpers.isJS();

		slider.init();
		animations.init();
	},

	onscroll(position) {
		if (position > 100) {
			if (!document.querySelector('.header').classList.contains('scrolled')) {
				document.querySelector('.header').classList.add('scrolled');
			}
		} else {
			document.querySelector('.header').classList.remove('scrolled');
		}
	},

	autocomplete(element) {
		var data = [
			['Praha', 'Brno', 'Ostrava'],
			['Locus', 'HubHub', 'Impact Hub'],
		];

		var resultElemenet = document.querySelector('.searchForm__results');

		var resultsTown = '';
		var resultsCoworks = '';
		var resultsFinal = '';

		if (element.value.length >= 1) {
			element.parentElement.classList.add('shown-results');

			data[1].forEach((value) => {
				if (value.toLowerCase().includes(element.value.toLowerCase())) {
					var coworkSlug = value.toLowerCase().replace(' ', '-');
					resultsCoworks = resultsCoworks + '<a href="/cowork/' + coworkSlug + '/">' + value + '</a>';
				}
			});

			if (resultsCoworks !== 'undefined' && resultsCoworks !== '') {
				resultsFinal = resultsFinal + '<h3>Nalezené coworky</h3>' + resultsCoworks;
			}

			data[0].forEach((value) => {
				if (value.toLowerCase().includes(element.value.toLowerCase())) {
					var townSlug = value.toLowerCase().replace(' ', '-');
					resultsTown = resultsTown + '<a href="/' + townSlug + '/">' + value + '</a>';
				}
			});

			if (resultsTown !== 'undefined' && resultsTown !== '') {
				console.log(resultsTown);
				resultsFinal = resultsFinal + '<h3>Nalezená města</h3>' + resultsTown;
			}

			if (resultsFinal !== 'undefined' && resultsFinal !== '') {
				resultElemenet.innerHTML = resultsFinal;
			} else {
				resultElemenet.innerHTML = '<h3>Nic nenazeleno</h3>';
			}
		} else {
			resultElemenet.innerHTML = '';
			element.parentElement.classList.remove('shown-results');
		}
	},
};

// Define a convenience method and use it
var ready = (callback) => {
	if (document.readyState != 'loading') callback();
	else document.addEventListener('DOMContentLoaded', callback);
};

ready(() => {
	theme.init();
});

let last_known_scroll_position = 0;
let ticking = false;

window.addEventListener('scroll', function (e) {
	last_known_scroll_position = window.scrollY;

	if (!ticking) {
		window.requestAnimationFrame(function () {
			theme.onscroll(last_known_scroll_position);
			ticking = false;
		});

		ticking = true;
	}
});
